import React from 'react';
import { Button, Box } from '@mui/material';
import DialogModal from '../../../components/DialogModal';
import TextFieldWithIcon from '../../../components/TextInputWithIcon/TextInputWithIcon';
import { BusDialogProps } from '../types/busTypes';

const BusDialog: React.FC<BusDialogProps> = ({
  open,
  values,
  errors,
  loading,
  onClose,
  onChange,
  onSubmit,
  title,
  submitLabel,
  busId
}) => {
  const isSubmitDisabled =
    loading || !values.name.trim() || !values.licensePlateNo.trim();
  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title={title || 'Enroll A Bus'}
      actions={
        <>
          <Button onClick={onClose} disabled={loading} variant='outlined'>
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            disabled={isSubmitDisabled}
            variant='contained'
            loading={loading}
          >
            {submitLabel}
          </Button>
        </>
      }
      maxWidth='sm'
    >
      <Box display='flex' flexDirection='column'>
        {busId && (
          <Box display='flex' flexDirection='column' mb={2}>
            <TextFieldWithIcon label='Bus ID' value={busId} disabled />
          </Box>
        )}
        <Box display='flex' flexDirection='row'>
          <Box display='flex' flexDirection='column' mb={1} mr={1} flex={1}>
            <TextFieldWithIcon
              label='Bus Name'
              required
              value={values.name}
              onChange={(e) => onChange('name', e.target.value)}
              error={Boolean(errors.name)}
              helperText={errors.name}
              placeholder='Enter Bus Name'
            />
          </Box>
          <Box display='flex' flexDirection='column' mb={1} flex={1}>
            <TextFieldWithIcon
              label='License Plate'
              required
              value={values.licensePlateNo}
              onChange={(e) => onChange('licensePlateNo', e.target.value)}
              error={Boolean(errors.licensePlateNo)}
              helperText={errors.licensePlateNo}
              placeholder='Enter License Plate Number'
            />
          </Box>
        </Box>
      </Box>
    </DialogModal>
  );
};

export default BusDialog;
